<!-- eslint-disable vue/no-deprecated-v-bind-sync -->
<template>
    <div>
        <h2>Holidays</h2>
        <el-button
            class="el-button--corwin-green mb-20"
            icon="el-icon-plus"
            style="width: 250px"
            @click="createView"
        >
            Add Holiday
        </el-button>
        <template>
            <el-table
                :data="holidays"
                :default-sort="{ prop: 'id', order: 'ascending' }"
                style="width: 100%"
            >
                <el-table-column label="ID" prop="id" sortable>
                </el-table-column>
                <el-table-column label="Name" prop="name" sortable>
                </el-table-column>
                <el-table-column label="Date">
                    <template v-slot="scope">
                        <p>
                            {{ datetimeFormat(scope.row.from) }} -
                            {{ datetimeFormat(scope.row.to) }}
                        </p>
                    </template>
                </el-table-column>
                <el-table-column label="Holidays" prop="days">
                </el-table-column>
                <el-table-column label="Action">
                    <template v-slot="scope">
                        <el-button
                            size="mini"
                            @click="handleEdit(scope.$index, scope.row)"
                            >Edit</el-button
                        >
                        <el-button
                            size="mini"
                            type="danger"
                            @click="handleDelete(scope.$index, scope.row)"
                            >Delete</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </template>
        <el-dialog
            :title="formTitle"
            :visible.sync="dialogVisible"
            width="30%"
            :before-close="handleClose"
        >
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
                <el-form-item
                    label="Name"
                    prop="name"
                    style="margin-bottom: 10px"
                >
                    <br />
                    <el-input
                        v-model="ruleForm.name"
                        placeholder="Enter Name"
                    ></el-input>
                </el-form-item>
                <el-row class="mb-20">
                    <el-col :span="11">
                        <el-form-item label="From" prop="from">
                            <el-date-picker
                                v-model="ruleForm.from"
                                type="date"
                                placeholder="Pick a date"
                                style="width: 100%"
                                value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="2" class="line">-</el-col>
                    <el-col :span="11">
                        <el-form-item label="To" prop="to">
                            <el-date-picker
                                v-model="ruleForm.to"
                                type="date"
                                placeholder="Pick a date"
                                style="width: 100%"
                                value-format="yyyy-MM-dd"
                                value="yyyy-MM-dd"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item style="text-align: right">
                    <el-button
                        @click="handleClose"
                        type="danger"
                        style="width: 200px"
                        >Close</el-button
                    >
                    <el-button
                        type="primary"
                        @click="submitForm('ruleForm')"
                        style="width: 200px"
                        >{{ formSubmitbtn }}</el-button
                    >
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import auth from "@/mixins/auth";

export default {
    mixins: [auth],
    props: {},
    directives: {},
    components: {},
    data() {
        return {
            ruleForm: {
                name: "",
                from: "",
                to: "",
            },
            dialogVisible: false,
            formTitle: "Add Holiday",
            formSubmitbtn: "Save",
            rules: {
                name: [
                    {
                        required: true,
                        message: "Please Enter Discount Name",
                        trigger: "blur",
                    },
                ],
                from: [
                    {
                        required: true,
                        message: "Please pick a date",
                        trigger: "change",
                    },
                ],
                to: [
                    {
                        required: true,
                        message: "Please pick a date",
                        trigger: "change",
                    },
                ],
            },
            holiday: null,
            holidays: [],
        };
    },
    mounted() {
        this.getHolidays();
    },
    methods: {
        getHolidays() {
            axios.get(`/web-api/holiday`).then((response) => {
                this.holidays = response.data.data;
            });
        },
        createView() {
            this.formTitle = "Add Holiday";
            this.formSubmitbtn = "Save";
            this.resetForm();
            this.dialogVisible = true;
        },
        resetForm() {
            this.ruleForm.name = "";
            this.ruleForm.from = "";
            this.ruleForm.to = "";
        },
        handleClose() {
            this.$confirm("Are you sure to close this dialog?")
                .then((_) => {
                    this.$refs["ruleForm"].resetFields();
                    this.dialogVisible = false;
                })
                .catch(() => {
                    //do nothing
                });
        },
        submitForm(form) {
            this.$refs[form].validate((valid) => {
                if (valid) {
                    if (this.ruleForm.to >= this.ruleForm.from) {
                        if (this.holiday) {
                            axios
                                .put(
                                    `/web-api/holiday/${this.holiday.id}`,
                                    this.ruleForm,
                                )
                                .then((response) => {
                                    this.$toastr("add", {
                                        title: "Update",
                                        msg: "Holiday updated successfully",
                                        clickClose: true,
                                        timeout: 1500,
                                        position: "toast-top-right",
                                        type: "success",
                                    });
                                    this.getHolidays();
                                    this.$refs[form].resetFields();
                                    this.dialogVisible = false;
                                });
                        } else {
                            axios
                                .post(`/web-api/holiday`, this.ruleForm)
                                .then((response) => {
                                    this.$toastr("add", {
                                        title: "Added",
                                        msg: "Holiday added successfully",
                                        clickClose: true,
                                        timeout: 1500,
                                        position: "toast-top-right",
                                        type: "success",
                                    });
                                    this.getHolidays();
                                    this.resetForm();
                                    this.$refs[form].resetFields();
                                    this.dialogVisible = false;
                                });
                        }
                    } else {
                        this.$toastr("add", {
                            title: "Alert",
                            msg: "To date should be greater than or equal to From date!",
                            clickClose: true,
                            timeout: 3000,
                            position: "toast-top-right",
                            type: "warning",
                        });
                    }
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        datetimeFormat(date) {
            return moment(date).format("MMM DD, YYYY hh:mma");
        },
        handleEdit(index, row) {
            this.formTitle = "Update Discount";
            this.formSubmitbtn = "Update";
            this.resetForm();
            this.holiday = row;
            this.ruleForm.name = this.holiday.name;
            this.ruleForm.from = moment(this.holiday.from).format("YYYY-MM-DD");
            this.ruleForm.to = moment(this.holiday.to).format("YYYY-MM-DD");
            this.dialogVisible = true;
        },
        handleDelete(index, row) {
            this.$confirm("Deletion is permanent: ARE YOU SURE?")
                .then((_) => {
                    axios
                        .delete(`/web-api/holiday/${row.id}`)
                        .then((response) => {
                            this.$toastr("add", {
                                title: "Deleted",
                                msg: "Holiday deleted successfully",
                                clickClose: true,
                                timeout: 1500,
                                position: "toast-top-right",
                                type: "success",
                            });
                            this.getHolidays();
                        });
                })
                .catch(() => {
                    //do nothing
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.el-checkbox,
.el-radio {
    display: block;
}
.dialog-footer {
    text-align: left !important;
}
.discount {
    width: 50%;
    border-top: 1px solid #000;
    margin-top: 30px;
}
.line {
    color: #fff;
}
</style>
